"use strict";
import { jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import Auth from "../util/auth";
function BeamerUpdates() {
  const [messageCount, setMessageCount] = useState(0);
  const handleClickBeamer = () => {
    if (typeof Beamer !== "undefined") {
      Beamer.show();
      setMessageCount(0);
    }
  };
  const handleInitBeamer = () => {
    var _a;
    const user = Auth.getCurrentUser();
    if (user && user.account && typeof Beamer !== "undefined") {
      const isFactorAccount = user.account.factor_account;
      const isNextGenAudit = ((_a = user.account.settings) == null ? void 0 : _a.next_gen_audit) || false;
      const config = {
        callback: handleSetMessageCount,
        filter: (isFactorAccount ? "factor" : "broker") + ";payables",
        user_email: user.email,
        user_id: user.id,
        next_gen_audit: isNextGenAudit
      };
      Beamer.update(config);
      Beamer.init();
    }
  };
  const handleSetMessageCount = (messageCount2) => {
    setMessageCount(messageCount2);
  };
  useEffect(() => {
    handleInitBeamer();
  }, []);
  return /* @__PURE__ */ jsxs("a", { "data-component": "BeamerUpdates", onClick: handleClickBeamer, children: [
    "Updates",
    messageCount ? ` (${messageCount})` : ""
  ] });
}
export default BeamerUpdates;
